import React, { useEffect, useState, useCallback } from 'react';
import parse from 'html-react-parser';
import { Container } from 'reactstrap';
import { useHomeContext } from '../../contexts/HomeContext';
import { useLanguageContext } from '../../contexts/LanguageContext';
import { useConfigContext } from '../../contexts/ConfigContext';
import HelpBlock from './components/HelpBlock';
import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';
import {
  Banner,
  BannerText,
  BannerTitle,
  BannerDescription,
  BannerContainer,
  BannerSignIn,
} from './style';
import SignIn from './components/SignIn';
import FinancingSolutionsMenu from './components/FinancingSolutionsMenu';
import FinancingSolutions from './components/FinancingSolutions';
import Chat from '../../components/Chat';
import { useLabelsContext } from '../../contexts/LabelsContext';
import { createSafeHtml } from '../../utils/sanitizeHtml';

const HomeComponent = () => {
  const { banner, modules } = useHomeContext();
  const { TOGGLE } = useConfigContext();
  const { language } = useLanguageContext();
  const { labels } = useLabelsContext();
  const [modal, setModal] = useState(false);
  const [failLoginAttempt, setFailLoginAttempt] = useState(false);
  const [modalContent, setModalContent] = useState(undefined);
  const [modalErrorContent, setModalErrorContent] = useState(undefined);

  const toggleModal = useCallback(() => {
    setModal(prevModal => !prevModal);
  }, []);

  const toggleFailLoginAttemptModal = useCallback(() => {
    setFailLoginAttempt(prevModal => !prevModal);
  }, []);

  useEffect(() => {
    document.title = "Dell Financial Services";
    const onLoginFail = () => toggleFailLoginAttemptModal();
    window.addEventListener("loginFailedEvent", onLoginFail);
    return () => {
      window.removeEventListener("loginFailedEvent", onLoginFail)
    }
  }, [toggleFailLoginAttemptModal]);

  useEffect(() => {

    if (Object.keys(labels).length > 0) {
      const usExperience = {
        header: labels.account_announcement_title,
        body: labels.account_announcement,
        confirmationLabel: labels.account_announcement_confirmation,
      };

      const failLoginLabels = {
        header: labels.fail_login_modal_title,
        body: labels.fail_login_modal_content,
        confirmationLabel: labels.fail_login_modal_close,
      };

      setModalContent(usExperience);
      setModalErrorContent(failLoginLabels);

      if (labels?.account_announcement_title !== "") {
        toggleModal();
      }
    }

  }, [labels, setModalContent, setModalErrorContent, toggleModal]);

  return (
    <>
      <Chat />
      <Banner image={banner.bannerUrl}>
        <BannerContainer>
          <BannerText>
            <BannerDescription>{banner.title}</BannerDescription>
            <BannerTitle dangerouslySetInnerHTML={createSafeHtml(banner.description)} />
          </BannerText>
          <BannerSignIn id="bannerSignIn">
            <SignIn hideSigninFooter={language.locale.toLowerCase() !== 'en-us'} />
          </BannerSignIn>
        </BannerContainer>
      </Banner>
      <FinancingSolutionsMenu financingSolutions={modules} />
      <Container className="container-fluid container-xl">
        <FinancingSolutions financingSolutions={modules} />
        <HelpBlock />
      </Container>

      <div>
        {"en-us".includes(language.locale.toLowerCase()) && (
          <>
            <Modal isOpen={modal} toggle={toggleModal}>
              <ModalHeader toggle={toggleModal}>{modalContent?.header}</ModalHeader>
              {(modalContent?.body && modalContent?.confirmationLabel) && (
                <ModalBody>
                  <div>{parse(modalContent?.body || "")}</div>
                  <Button style={{ float: "right" }} color="primary" onClick={toggleModal}>
                    {modalContent?.confirmationLabel}
                  </Button>
                </ModalBody>
              )}
            </Modal>

            <Modal isOpen={failLoginAttempt && !!modalErrorContent?.body} toggle={toggleFailLoginAttemptModal}>
              <ModalHeader toggle={toggleFailLoginAttemptModal}> {modalErrorContent?.header}</ModalHeader>
              {(modalErrorContent?.body && modalErrorContent?.confirmationLabel) && (
                <ModalBody>
                  <div>{parse(modalErrorContent?.body)}</div>
                  <Button style={{ float: "right" }} color="primary" onClick={toggleFailLoginAttemptModal}>
                    {modalErrorContent?.confirmationLabel}
                  </Button>
                </ModalBody>
              )}
            </Modal>
          </>
        )}
      </div>
    </>
  );
};

export default HomeComponent;